import React from 'react';
import {
  User, Building2, ShoppingBag, TrendingUp,
  CreditCard, Bell, Package, Star,
  Shield, Lock, HelpCircle
} from 'lucide-react';
import './BrandAccountSidebar.css';

const BrandAccountSidebar = ({ activeSection, onSectionChange }) => {
  const menuItems = [
    { id: 'mycollab', label: 'MyCollab', icon: <ShoppingBag size={20} /> },
    { id: 'profile', label: 'My Profile', icon: <User size={20} /> },
    { id: 'brands', label: 'My Brands', icon: <Building2 size={20} /> },
    { id: 'sales', label: 'Sales', icon: <TrendingUp size={20} /> },
    // { id: 'subscriptions', label: 'Subscriptions', icon: <ShoppingBag size={20} /> }, // DISABLED
    // { id: 'billing', label: 'Billing', icon: <CreditCard size={20} /> }, // DISABLED
    // { id: 'notifications', label: 'Notifications', icon: <Bell size={20} /> }, // DISABLED
    // { id: 'shipments', label: 'Shipments', icon: <Package size={20} /> }, // DISABLED
    { id: 'reviews', label: 'Reviews', icon: <Star size={20} /> },
    { id: 'security', label: 'Security', icon: <Shield size={20} /> },
    { id: 'privacy', label: 'Privacy', icon: <Lock size={20} /> },
    { id: 'support', label: 'Support', icon: <HelpCircle size={20} /> }
  ];

  return (
    <div className="brand-account-sidebar">
      <div className="sidebar-header">
        <h2 className="sidebar-title">Account Settings</h2>
      </div>

      <nav className="sidebar-menu">
        {menuItems.map((item) => (
          <button
            key={item.id}
            className={`sidebar-menu-item ${activeSection === item.id ? 'active' : ''}`}
            onClick={() => onSectionChange(item.id)}
          >
            <span className="menu-icon">{item.icon}</span>
            <span className="menu-label">{item.label}</span>
          </button>
        ))}
      </nav>
    </div>
  );
};

export default BrandAccountSidebar;

